<template>
  <section class="banner-section">
    <div class="banner-inner">
      <div class="banner-text-wrap">
        <h1 class="banner-title">สั่งอาหาร–ช้อปของใช้ ครบจบในแอปเดียว</h1>
        <p class="banner-subtitle">
          สั่งอาหารอร่อยและช้อปของใช้จำเป็นได้ง่ายๆ ในที่เดียว สะดวก
          ประหยัดเวลา ส่งตรงถึงหน้าบ้านคุณทุกวัน
          พร้อมโปรโมชั่นสุดคุ้มจากร้านค้าชั้นนำ
          และบริการส่งที่รวดเร็วทั่วประเทศ
        </p>
        <v-btn
          color="#F4811F"
          class="banner-btn"
          large
          rounded
          @click="$router.push({ name: 'marketplace' })"
        >
          สั่งเลย
        </v-btn>
      </div>

      <div class="banner-image-wrap">
        <v-img
          :src="require('@/assets/delivery/banner.png')"
          alt="Delivery Banner"
          class="banner-img"
          :height="$vuetify.breakpoint.smAndDown ? 220 : 750"
          cover
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Banner",
};
</script>

<style scoped>
.banner-section {
  width: 100%;
  overflow: hidden;
  background: #f5e9e9;
}

.banner-inner {
  display: flex;
  align-items: center;
  max-width: 1440px;
  margin: 0 auto;
}

.banner-image-wrap {
  flex: 0 0 50%;
  max-width: 50%;
  overflow: hidden;
}

.banner-img {
  width: 100%;
  height: 750px;
}

.banner-text-wrap {
  flex: 0 0 50%;
  max-width: 50%;
  padding: 48px 64px;
  box-sizing: border-box;
}

.banner-title {
  font-size: 40px;
  font-weight: 700;
  color: #111827;
  font-family: "Noto Sans Thai", system-ui, Arial, sans-serif;
  line-height: 1.3;
  margin-bottom: 14px;
}

.banner-subtitle {
  font-size: 17px;
  color: #4b5563;
  line-height: 1.6;
  margin-bottom: 28px;
}

.banner-btn {
  color: #fff !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  padding: 10px 36px !important;
  letter-spacing: 0;
}

@media (max-width: 960px) {
  .banner-inner {
    flex-direction: column;
  }

  .banner-image-wrap {
    order: -1;
    width: 100%;
    max-width: 100%;
    flex: none;
  }

  .banner-text-wrap {
    order: 0;
    flex: none;
    width: 100%;
    max-width: 100%;
    padding: 28px 24px 36px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .banner-title {
    font-size: 22px;
    margin-bottom: 12px;
  }

  .banner-subtitle {
    font-size: 15px;
    margin-bottom: 24px;
  }
}
</style>
